import angular from "angular";

/**
 * @deprecated
 */
export class ProductRestService implements qpmn.product.rest.IProductRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }

    /**
     * @description 简易价格计算
     * @param configurableProductId 可配置产品ID
     * @returns 
     */
    public list(configurableProductId: number): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.pricing.model.domain.IProductPrice>>> {
        return this.$rest.http<Array<qpmn.product.pricing.model.domain.IProductPrice>>("productRestService", "list", {
            productId: configurableProductId
        });
    }


    /**
     * @description post简易价格计算
     * @param productId 产品ID
     * @param sourceDataDTO
     * @returns 
     */
    public listPost(productId: number, productData: any): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.pricing.model.domain.IProductPrice>>> {
        return this.$rest.http<Array<qpmn.product.pricing.model.domain.IProductPrice>>("productRestService", "listPost", {
            productId: productId,
            product: productData,
            qty: 0
        });
    }
    /**
    * @description list post特定价格计算（地区）
    * @param productId 产品ID
    * @param sourceDataDTO
    * @param region
    * @returns 
    */

    public regionListPost(productId: number, productData: any, region: string): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.pricing.model.domain.IProductPrice>>> {
        return this.$rest.http<Array<qpmn.product.pricing.model.domain.IProductPrice>>("productRestService", "listPost", {
            productId: productId,
            product: productData,
            qty: 0
        }, {
            "saleRegions-country": region
        });
    };

    /**
    * @description list post特定价格计算（us）
    * @param productId 产品ID
    * @param sourceDataDTO
    * @returns 
    */

    public usRegionListPost(productId: number, sourceDataDTO: any): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.pricing.model.domain.IProductPrice>>> {
        return this.regionListPost(productId, sourceDataDTO, "US");
    };


    // TODO product参数类型未定义
    /**
     * @description 复杂价格计算(通过产品属性)
     * @param configurableProductId 可配置产品ID
     * @param product 
     * @param quantities 价格区间
     * @returns 
     */
    public matrix(configurableProductId: number, product, quantities: Array<number>): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.pricing.model.domain.IMatrix>> {
        return this.$rest.http<qpmn.product.pricing.model.domain.IMatrix>("productRestService", "matrix", {
            productId: configurableProductId,
            product: product,
            quantities: quantities
        });
    }


    /**
     * @description 特定价格计算（地区）
     * @param configurableProductId 可配置产品ID
     * @returns 
     */
    public specificList(configurableProductId: number): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.pricing.model.domain.IProductPrice>>> {
        return this.$rest.http<Array<qpmn.product.pricing.model.domain.IProductPrice>>("productRestService", "specificList", {
            productId: configurableProductId
        });
    }


    /**
     * @description 特定价格计算（地区）
     * @param configurableProductId 可配置产品ID
     * @returns 
     */
    public regionList(configurableProductId: number, region: string): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.pricing.model.domain.IProductPrice>>> {
        return this.$rest.http<Array<qpmn.product.pricing.model.domain.IProductPrice>>("productRestService", "list", {
            productId: configurableProductId
        }, {
            "saleRegions-country": region
        });
    }

    /**
     * @description 特定价格计算（美国地区）
     * @param configurableProductId 可配置产品ID
     * @returns 
     */
    public usRegionList(configurableProductId: number): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.product.pricing.model.domain.IProductPrice>>> {
        return this.regionList(configurableProductId, "US");
    }

    /**
      * @description 特定价格计算（地区）
     * @param configurableProductId 可配置产品ID
     * @param product 
     * @param quantities 价格区间
     * @param region 地区code
      * @returns 
      */
    public regionMatrixList(configurableProductId: number, product, quantities: Array<number>, region: string): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.pricing.model.domain.IMatrix>> {
        return this.$rest.http<qpmn.product.pricing.model.domain.IMatrix>("productRestService", "matrix", {
            productId: configurableProductId,
            product: product,
            quantities: quantities
        }, {
            "saleRegions-country": region
        });
    }
    // TODO product参数类型未定义
    /**
     * @description 复杂价格计算(通过产品属性)
     * @param configurableProductId 可配置产品ID
     * @param product 
     * @param quantities 价格区间
     * @returns 
     */
    public specificMatrix(configurableProductId: number, product, quantities: Array<number>): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.pricing.model.domain.IMatrix>> {
        return this.$rest.http<qpmn.product.pricing.model.domain.IMatrix>("productRestService", "specificMatrix", {
            productId: configurableProductId,
            product: product,
            quantities: quantities
        });
    }

    /**
     * @description: 获取productInstanceProjectName
     * @param {string} id
     * @return {*}
     */
    public getProductInstanceProjectName(id: string): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.model.domain.IProductInstance>> {
        return this.$rest.http<qpmn.product.model.domain.IProductInstance>("productRestService", "getProductInstanceProjectName", {
            id: id
        });
    }

    /**
     * @description 获取产品数据
     * @param configurableProductId 
     * @returns 
     */
    public getProductData(configurableProductId: number, versionedProductAttributeId?: number): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.product.productData.model.domain.IProductData>> {
        return this.$rest.http<qpmn.product.productData.model.domain.IProductData>("productRestService", "getProductData", {
            productId: configurableProductId,
            versionedProductAttributeId: versionedProductAttributeId
        });
    }

}